<script setup lang="ts">
import { ElPopover } from 'element-plus';
import { computed } from 'vue';

import { useBreakpoints } from '@shop/composables/useBreakpoints';

import type { Props } from '@shop/components/ui/InfoHover.types';

import 'element-plus/theme-chalk/el-popover.css';

const props = withDefaults(defineProps<Props>(), {
  direction: 'auto',
  tight: false,
  arrow: true,
});

const { isMobile } = useBreakpoints();

const placement = computed(() => {
  if (props.direction !== 'auto') {
    return props.direction;
  }

  return isMobile.value ? 'bottom-start' : 'right';
});

const popoverWidth = computed(() => {
  if (props.tight && !isMobile.value) {
    return undefined;
  }

  return props.tight ? 275 : 265;
});
</script>

<template>
  <ElPopover
    :placement="placement"
    trigger="hover"
    :show-arrow="arrow"
    popper-class="info-hover"
    :width="popoverWidth"
    teleported
  >
    <template #reference>
      <span class="info-hover__container" @click.stop>
        <span class="info-hover__target">i</span>
      </span>
    </template>
    <div class="info-hover__inner" :class="{ 'info-hover__inner--tight': tight }">
      <slot />
    </div>
  </ElPopover>
</template>
